export const buildRgbString = (red: number, green: number, blue: number): string => {
  return `rgb(${red}, ${green}, ${blue})`;
}